import {useCallback} from 'react'

import {useMetrikaContext} from '../Context'
import {Metrika} from '../types'

export default function useTrackGACallback() {
  const context = useMetrikaContext()

  return useCallback<Metrika['trackGA']>((...args) => context.current.trackGA(...args), [context])
}
